import { Document } from "../interfaces/rich-text-types";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import RichTextEditor from "react-rte";

export function documentToMarkdown(doc: Document) {
    return RichTextEditor.createValueFromString(documentToHtmlString(doc), "html").toString(
        "markdown"
    );
}
